export const ROUTE_SECTIONS = [
  { id: 'messages', to: '/messages', label: '消息' },
  { id: 'customers', to: '/customers', label: '客户' },
  { id: 'tasks', to: '/tasks', label: '任务' },
  { id: 'analytics', to: '/analytics', label: '数据' },
  { id: 'channels', to: '/channels', label: '渠道' },
];

export const SETTINGS_ROUTE = { id: 'settings', to: '/settings', label: '设置' };

export const ROUTE_SECTION_BY_PATH = {
  '/': 'messages',
  '/messages': 'messages',
  '/customers': 'customers',
  '/tasks': 'tasks',
  '/analytics': 'analytics',
  '/channels': 'channels',
  '/settings': 'settings',
};

export function getRouteSection(pathname = '/') {
  return ROUTE_SECTION_BY_PATH[pathname] || 'messages';
}
